module.exports = __webpack_public_path__ + "img/Mercado_Libre.b93dcba6.png";